import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../lib/config';

function ResetPassword() {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState(null);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Supabase sends the token in the URL hash: #access_token=...&type=recovery
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const token = params.get('access_token');
    if (!token) {
      setError('This reset link is invalid or has expired. Please request a new one.');
    } else {
      setAccessToken(token);
    }
  }, []);

  async function handleSubmit() {
    setError(null);
    if (!password || password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/confirm-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ access_token: accessToken, new_password: password }),
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.detail || 'Something went wrong.');
        setLoading(false);
        return;
      }
      setDone(true);
    } catch {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  }

  if (done) {
    return (
      <div style={{ maxWidth: '400px', margin: '80px auto', padding: '24px', textAlign: 'center' }}>
        <h2>Password updated</h2>
        <p>You can now log in with your new password.</p>
        <button onClick={() => navigate('/login')}>Go to login</button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '400px', margin: '80px auto', padding: '24px' }}>
      <h2>Set a new password</h2>
      {error && !accessToken ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <>
          <input
            type="password"
            placeholder="New password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
            style={{ width: '100%', padding: '10px', marginBottom: '12px' }}
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && !loading && handleSubmit()}
            disabled={loading}
            style={{ width: '100%', padding: '10px', marginBottom: '12px' }}
          />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <button onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: '10px' }}>
            {loading ? 'Updating...' : 'Update password'}
          </button>
        </>
      )}
    </div>
  );
}

export default ResetPassword;